export default __webpack_public_path__ + "media/logo.ce7df2cda34cb01e3ab4a895bd4d5d6d.webp";